export default __webpack_public_path__ + "static/media/alert-yellow.dddcc677.svg";